import React, { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import TextInput from '../TextInput';
import { useGetWebleadFromCookie } from '../../customHooks';

import { klaviyoNewsletterOperations } from '@evdy/web-redux/dist/lib/klaviyoNewsletter';

import styles from './KlaviyoNewsletter.module.scss';
const {
  klaviyoNewsletterSignup,
  klaviyoIdentify,
  klavioTrackNewsletter
} = klaviyoNewsletterOperations;

const {
  'newsletter-form-wrapper': newsletterWrapperClass,
  'newsletter-info': newsletterInfoClass,
  'newsletter-input': newsletterInputClass,
  'newsletter-label': newsletterLabelClass,
  'newsletter-footnote': newsletterFootnoteClass,
  'success-message-wrapper': successMessageClass,
  'success-message-title': successMessageTitleClass,
  'success-message-subtitle': successMessageSubtitleClass
} = styles;

const getKlaviyoEmail = () => {
  if (global.window && window._learnq) {
    // sentry caught an error where _learnq.identify is not a fn
    // possible race condition
    if (typeof window._learnq.identify === 'function') {
      const { $email: email } = window._learnq?.identify();
      return email;
    }
  }
};

const SuccessMessage = () => (
  <div className={successMessageClass}>
    <h3 className={successMessageTitleClass}>Thanks for subscribing!</h3>
    <p className={successMessageSubtitleClass}>Check your email for a confirmation message.</p>
  </div>
);

const KlaviyoNewsletter = () => {
  const { user, isFetchingNewsletter, lastUpdatedNewsletter, webLeadEmail } = useSelector(
    ({ authUser, klaviyoNewsletter, webPurchase }) => ({
      user: authUser.data,
      isFetchingNewsletter: klaviyoNewsletter.isFetching,
      lastUpdatedNewsletter: klaviyoNewsletter.lastUpdated,
      webLeadEmail: webPurchase.purchaseFlow?.data?.email
    })
  );
  const { name, address, dateOfBirth, phone } = user || {};
  const { first: firstName, last: lastName } = name || {};
  const { zip } = address || {};

  const showSuccess = !isFetchingNewsletter && lastUpdatedNewsletter >= Date.now() - 5e2;

  const dispatch = useDispatch();

  const [currentKlaviyoEmail, setKlaviyoEmail] = useState('');

  const initialEmail = currentKlaviyoEmail ? currentKlaviyoEmail : '';

  useLayoutEffect(() => {
    const klaviyoEmail = getKlaviyoEmail();
    setKlaviyoEmail(klaviyoEmail || webLeadEmail || '');
  }, [webLeadEmail]);

  useGetWebleadFromCookie();

  const emailRegex = /^\S+@\S+\.\S+$/;

  const NewsletterSubscribeSchema = Yup.object().shape({
    email: Yup.string()
      .matches(emailRegex, 'Valid email is required')
      .required('Email is required!')
  });

  const onSubmit = ({ email }) => {
    klaviyoIdentify({
      firstName,
      lastName,
      zip,
      birthdate: dateOfBirth,
      phone,
      email
    });
    klavioTrackNewsletter();
    dispatch(klaviyoNewsletterSignup({ email }));
  };

  return showSuccess ? (
    <SuccessMessage />
  ) : (
    <div className={newsletterWrapperClass}>
      <div className={newsletterInfoClass}>
        <h3>Our Newsletter</h3>
        <p>Sign up to get updates on packages, location availability and more.</p>
      </div>
      <Formik
        initialValues={{ email: initialEmail }}
        validationSchema={NewsletterSubscribeSchema}
        onSubmit={onSubmit}
        enableReinitialize
        validateOnMount={true}
      >
        <Form>
          <TextInput
            type="email"
            name="email"
            placeholder={'Enter your email'}
            customInputClass={newsletterInputClass}
            customLabelClass={newsletterLabelClass}
            customFootnoteClass={newsletterFootnoteClass}
          />
          <button type="submit">Subscribe</button>
        </Form>
      </Formik>
    </div>
  );
};

export default KlaviyoNewsletter;
